export const getApiUrl = (url: string): string => {
  const parts = url.split('.');
  return parts.length > 1 ? `${parts[0]}.api.${parts.slice(1).join('.')}` : url;
};

export const formatUrl = (possibleUrl: string): string => {
  try {
    let url = possibleUrl.trim();

    if (!url.match(/^[a-zA-Z]+:\/\//)) {
      url = 'https://' + url;
    }

    const parsedUrl = new URL(url);

    return parsedUrl.origin;
  } catch (error) {
    throw new Error(`Invalid URL format: ${possibleUrl}`);
  }
};
